<template>
  <div
    :class="$style.wrapper"
    class="px-3 py-2"
  >
    <div :class="$style.content">
      <BaseAvatar
        :url="avatar"
        :size="45"
      />
      <span :class="$style.nameText">{{ name }}</span>
    </div>
  </div>
</template>

<script>
import BaseAvatar from '@/components/Atoms/BaseAvatar'

export default {
  name: 'ThePlayerScoreRow',
  components: {
    BaseAvatar,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    avatar: {
      type: String,
      required: true,
      default: null,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .wrapper {
    background-color: $color-white;
    margin-bottom: 1px;
  }
  .content{
    display: flex;
    align-items: center;
    .nameText {
      padding-left: 1rem;
      color: $color-midnight-blue;
      font-size: $font-size-small;
    }
  }
</style>
